import React, {ReactElement} from 'react';
import ResponsiveAppBar from "./app/components/ResponsiveAppBar";
import ApplicationOverview from "./app/pages/Application/Overview";
import RequestsOverview from "./app/pages/Requests/Overview";
import UsersOverview from "./app/pages/Users/Overview";
import Login from "./app/pages/Login";
import Layout from "./app/components/Layout";
import { Routes, Route } from 'react-router-dom';
import { useIdentity } from './app/hooks/useIdentity';

const App = (): ReactElement => {
    const [token, isAuthenticated, updateToken] = useIdentity();
    return (
        <>
            {isAuthenticated && <ResponsiveAppBar/>}
            <Layout>
                <Routes>
                    <Route path={'/applications'} element={<ApplicationOverview/>}/>
                    <Route path={'/applications/:id/requests'} element={<RequestsOverview/>}/>
                    <Route path={'/users'} element={<UsersOverview/>}/>
                    <Route path={'/'} element={<Login/>}/>
                </Routes>
            </Layout>
        </>
    );
}

export default App;
